import { Modal, Image, Card, Button, Tag } from 'antd';
import { useTranslation } from 'react-i18next';

const SubjectDetailsModal = ({ subject, open, onClose }) => {
  const { t } = useTranslation();

  if (!subject) return null;

  return (
    <Modal
      open={open}
      onCancel={onClose}
      width={400}
      height={650}
      centered
      footer={null}
      className="subject-detail-modal"
    >
      <div className="subject-modal-content">
        <div className="subject-modal-header" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#f5f5f5' }}>
          <Image
            src={subject.image_url || '/images/keaes_hd.png'}
            alt={subject.title}
            style={{ maxWidth: '100%', padding: '25px', height: '220px', objectFit: 'contain', borderTopLeftRadius: '8px', borderTopRightRadius: '8px' }}
            fallback="/images/keaes_hd.png"
            preview={false}
          />
        </div>

        <div className="subject-modal-title-overlay" style={{ textAlign: 'center', marginTop: '16px' }}>
          <h2 style={{ fontWeight: 'bold' }}>{subject.title}</h2>
        </div>

        <div>
          <Card bordered={false} style={{ backgroundColor: '#fafafa', borderRadius: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.05)' }}>
            
            <div style={{ marginBottom: '24px' }}>
              <span style={{ fontWeight: 'bold', color: '#555' }}>{t('level')}: </span>
              <Tag color="purple" style={{ marginLeft: 8 }}>{subject.level}</Tag>
            </div>

  

            <div style={{ marginBottom: '24px' }}>
              <span style={{ fontWeight: 'bold', color: '#555' }}>{t('description')}: </span>
              <div style={{ marginTop: 8, whiteSpace: 'pre-wrap' }}>{subject.description}</div>
            </div>

          </Card>

          <div style={{ textAlign: 'right', marginTop: '24px' }}>
            <Button type="primary" onClick={onClose} danger>{t('close')}</Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default SubjectDetailsModal;